<template>
	<div class="product-search-wrapper">
		<div class="container mb-5">
			<div class="row">
				<div class="col-xl-3 col-lg-4 col-md-5 mb-4">
					<div class="card card-filter">
						<div class="card-body">
							<div class="d-flex">
								<div class="card-filter-title">Lokasi</div>
								<div class="ml-auto">
									<button class="btn btn-sm btn-plain btn-collapse" data-toggle="collapse" :data-target="`#collapseLocation`" aria-expanded="false" :aria-controls="`collapseLocation`">
										<i class="bi-chevron-down"></i>
									</button>
								</div>
							</div>
							<div class="location-filter mt-3 ml-2 collapse show" id="collapseLocation">
								<div class="custom-control form-control-lg custom-checkbox" v-for="(location, index) in featuredLocations" :key="index">
									<input class="custom-control-input" type="checkbox" :value="location.value" :id="`location-${index}`" v-model="filterLocations" @change="applyFilter()">
									<label class="custom-control-label" :for="`location-${index}`">
										{{ location.name }}
									</label>
								</div>
								<div class="text-center">
									<button class="btn btn-plain text-primary font-weight-bold" data-toggle="modal" data-target="#locationModal">Lihat Semua</button>
								</div>
							</div>
							<hr>
							<div class="d-flex">
								<div class="card-filter-title">Harga</div>
								<div class="ml-auto">
									<button class="btn btn-sm btn-plain btn-collapse" data-toggle="collapse" :data-target="`#collapsePrice`" aria-expanded="false" :aria-controls="`collapsePrice`">
										<i class="bi-chevron-down"></i>
									</button>
								</div>
							</div>
							<div class="location-filter mt-3 ml-2 collapse show" id="collapsePrice">
								<div class="custom-control form-control-lg custom-checkbox" v-for="(price, index) in prices" :key="index">
									<input class="custom-control-input" type="checkbox" :value="price.value" :id="`price-${index}`" v-model="filterPrices" @change="uniqueCheck">
									<label class="custom-control-label" :for="`price-${index}`">
										{{ price.name }}
									</label>
								</div>
								<div class="my-2">Atur Harga</div>
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<span class="input-group-text" id="basic-addon1">Rp</span>
									</div>
									<input type="number" class="form-control" placeholder="Harga Minimum" aria-label="Harga Minimum" v-model="filterMinimumPrice" @keyup.enter="applyFilter" @change="applyFilter" :disabled="isFilterRangeDisabled">
								</div>
								<div class="input-group mb-3">
									<div class="input-group-prepend">
										<span class="input-group-text" id="basic-addon1">Rp</span>
									</div>
									<input type="number" class="form-control" placeholder="Harga Maximum" aria-label="Harga Maximum" v-model="filterMaximumPrice" @keyup.enter="applyFilter" @change="applyFilter" :disabled="isFilterRangeDisabled">
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xl-9 col-lg-8 col-md-7">
					<div class="row">
						<div class="col-md-12 mb-4">
							<div class="row d-flex align-items-center">
								<div class="col-md-6">
									<h2 class="text-bold mb-2">Semua Wishlist</h2>
								</div>
								<div class="col-md-6 d-flex justify-content-end align-items-center">
									<button class="btn btn-sm outline-primary mr-4 text-bold bulk-delete desktop-button"
										:class="{ 'is-loading': isDeletingWishlist }"
										:disabled="selectedProductIds.length <= 0"
										@click="bulkDelete"
										v-if="isEditMode">
										Hapus
										<span v-if="selectedProductIds.length > 0">({{ selectedProductIds.length }})</span>
									</button>
									<span class="mr-3" v-else-if="totalItems > 0"><b>{{ totalItems }}</b> Barang</span>
									<span class="text-primary text-bold cursor-pointer" @click="toggleEditMode(false)" v-if="!isEditMode">Atur</span>
									<span class="text-primary text-bold cursor-pointer" @click="toggleEditMode(true)" v-else>Batal</span>
								</div>
							</div>
							<!-- <div class="row">
								<div class="col-lg-6 col-xs-12 search-description align-self-center">
									<span :class="{ 'hidden': getParamsQuery('q') === '' }">Menampilkan hasil pencarian untuk <strong>"{{ getParamsQuery('q') }}".</strong></span>
								</div>
								<div class="col-lg-6 col-xs-12 d-flex">
									<div class="form-inline ml-lg-auto ml-xs-0">
										<label>Urutkan :</label>
										<select class="form-control ml-lg-2" v-model="selectedSortBy" @change="onChangeSortBy">
											<option value="created_at">Terbaru</option>
											<option value="cheapest">Termurah</option>
											<option value="expensive">Termahal</option>
											<option value="top-product" v-if="user">Terlaris</option>
										</select>
									</div>
								</div>
							</div> -->
						</div>
						<template v-if="!isLoading">
							<div v-for="(product, index) in products" :key="index" class="col-xl-3 col-lg-4 col-md-6 col-6 d-flex justify-content-center">
								<product-item
									:product="product"
									:is-edit-mode="isEditMode"
									@showDetail="showDetail(product)"
									@remove-wishlist="removeWishlist"
									@append-product-id="onAppendProductId"
									@remove-product-id="onRemoveProductId"
									:isGradientEnabled="isEditMode"
								/>
							</div>
							<div class="col-12" v-if="products.length < 1">
								<div class="card card-body card-product-empty border-0 d-flex">
									<div class="empty-description">
										Oops, Produk tidak ditemukan. Silahkan coba mengosongkan filter / menambahkan produk ke dalam Wishlist.
									</div>
								</div>
							</div>
						</template>
						<template v-else>
							<div v-for="(product, index) in dummyProducts" :key="index" class="col-xl-3 col-lg-4 col-md-6 col-6 d-flex justify-content-center">
								<product-item :is-loading="isLoading" />
							</div>
						</template>
					</div>

					<div class="d-flex" v-if="enablePagination">
						<pagination
							class="ml-auto"
							v-if="this.totalPages > 1"
							:total-pages="totalPages"
							:total="totalItems"
							:per-page="itemsPerPage"
							:current-page="page"
							:max-visible-buttons="maxVisibleButtons"
							@pagechanged="onPageChange"
						/>
						<div v-else></div>
					</div>
				</div>
			</div>

			<div class="modal" tabindex="-1" id="locationModal">
				<div class="modal-dialog modal-lg">
					<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Semua Lokasi</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<i class="bi bi-x-lg"></i>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<input type="email" class="form-control" id="search-location" placeholder="Cari nama Kota/Kabupaten" v-model="searchLocation">
						</div>
						<div class="location-conatiner">
							<div class="row" v-for="(province, index) in locations" :key="index">
								<div class="col-12 mb-2" :class="{ 'mt-3': index !== 0 }">
									<strong>{{ province._id }}</strong>
								</div>
								<template v-for="(city, i) in province.cities">
									<div class="col-4 mb-1"
										:key="i"
										v-if="city.city_name_with_type.toLowerCase().indexOf(searchLocation.toLowerCase()) !== -1"
									>
										<div class="custom-control form-control-md custom-checkbox">
											<input class="custom-control-input" type="checkbox" :value="city.city_id" :id="`location-all-${index}-${i}`" v-model="filterLocations">
											<label class="custom-control-label" :for="`location-all-${index}-${i}`">
												{{ city.city_name_with_type }}
											</label>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn-outline outline-warning o-sm" @click="filterLocations = []; searchLocation=''">Reset</button>
						<button type="button" class="btn-outline outline-primary o-sm" @click="applyFilter" data-dismiss="modal">Terapkan</button>
					</div>
					</div>
				</div>
			</div>
		</div>

		<nav class="navbar fixed-bottom bg-white mobile-button">
			<button class="btn outline-primary text-bold bulk-delete"
				:class="{ 'is-loading': isDeletingWishlist }"
				:disabled="selectedProductIds.length <= 0"
				@click="bulkDelete"
				v-if="isEditMode"
			>
				Hapus
				<span v-if="selectedProductIds.length > 0">({{ selectedProductIds.length }})</span>
			</button>
		</nav>

		<main-footer />
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import ProductItem from '@/components/homepages/sections/partials/ProductItem.vue';
import MainFooter from '@/components/homepages/Footer.vue';
import Pagination from '@/components/homepages/Pagination.vue';
import shippingApi from '@/api/shipping';
import homepageApi from '@/api/homepage';
import wishlistApi from '@/api/wishlist';
import {
	getAxiosErrorMessage,
} from '@/lib/helper';

import {
	homepageFilterprices,
	homepageFeaturedLocations,
	paginationMaxVisibleButtons,
} from '@/lib/statics';

export default {
	name: 'HomepageProductLists',
	components: {
		ProductItem,
		MainFooter,
		Pagination,
	},
	props: {
	},
	data() {
		return {
			keyword: '',
			page: 1,
			limit: 16,
			sort_by: 'created_at',
			sort: 'desc',
			selectedSortBy: 'created_at',
			dummyProducts: new Array(4),
			prices: homepageFilterprices,
			featuredLocations: homepageFeaturedLocations,
			filterLocations: [],
			filterPrices: [],
			filterMinimumPrice: '',
			filterMaximumPrice: '',
			isLoading: true,
			locations: [],
			isLocationSearching: false,
			products: [],
			searchLocation: '',
			totalPages: 0,
			totalItems: 0,
			itemsPerPage: 16,
			maxVisibleButtons: paginationMaxVisibleButtons,
			isEditMode: false,
			selectedProductIds: [],
			isDeletingWishlist: false,
		};
	},
	methods: {
		...mapActions({
			setSearchQuery: 'homepage/setSearchQuery',
			setSearchType: 'homepage/setSearchType',
			getDropshipProductAdded: 'homepage/getDropshipProductAdded',
			getProductWishlistAdded: 'wishlist/getProductWishlistAdded',
			bulkRemoveWishlistAdded: 'wishlist/bulkRemoveWishlistAdded',
		}),
		showDetail(product) {
			const encodedUserId = btoa(product.user._id.$oid);
			this.$router.push({ name: 'product-detail', params: { slug: `${product.slug}-${encodedUserId}` } });
		},
		getParamsQuery(param) {
			const result = this.$route.query[param];
			return result || '';
		},
		fetchCompleteCities() {
			this.locations = [];

			this.isLocationSearching = true;
			const params = {
				get_complete_data: 1,
				page: 1,
			};
			const callback = (response) => {
				const locations = response.data;
				this.locations = locations;
				this.isLocationSearching = false;
			};
			const errorCallback = (e) => {
				this.isLocationSearching = false;
				const message = getAxiosErrorMessage(e);
				console.log('message: ', message);
			};
			shippingApi.getCompleteCitiesGrouped(params, callback, errorCallback);
		},
		fetchProductsPublic() {
			this.isLoading = true;

			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				use_cache_header: true,
			};

			const keyword = this.searchQuery.trim() || this.getParamsQuery('q');
			if (keyword !== '') {
				params.keyword = keyword;
			}

			const type = this.searchType.trim() || this.getParamsQuery('st');
			if (type !== '') {
				params.type = type;
			}

			const category = this.getParamsQuery('c');
			if (category !== '' && category !== 'all') {
				params.category = category;
			}

			const subCategory = this.getParamsQuery('sc');
			if (subCategory !== '') {
				params.sub_category = subCategory;
			}

			const subSubCategory = this.getParamsQuery('ssc');
			if (subSubCategory !== '') {
				params.sub_sub_category = subSubCategory;
			}

			const locations = this.filterLocations;
			if (locations.length > 0) {
				params.locations = JSON.stringify(locations);
			}

			const prices = this.filterPrices;
			if (prices.length > 0) {
				params.prices = JSON.stringify(prices);
			}

			const minimumPrice = this.filterMinimumPrice;
			if (minimumPrice !== '') {
				params.minimum_price = minimumPrice;
			}

			const maximumPrice = this.filterMaximumPrice;
			if (maximumPrice !== '') {
				params.maximum_price = maximumPrice;
			}

			const callback = (response) => {
				const products = response.data.products;
				this.products = products;

				this.totalPages = response.data.page_info.last_page;
				this.totalItems = response.data.page_info.total_all_products;
				this.itemsPerPage = response.data.page_info.total_products;

				// set pagination max visible button
				this.maxVisibleButtons = this.totalPages;
				if (this.totalPages > paginationMaxVisibleButtons) {
					this.maxVisibleButtons = paginationMaxVisibleButtons;
				}

				this.isLoading = false;
			};

			const errorCallback = () => {
				this.products = [];
				this.resetPagination();
				this.isLoading = false;
			};

			homepageApi.getWishlistProducts(params, callback, errorCallback);
		},
		resetPagination() {
			this.page = 1;
			this.totalPages = 0;
			this.totalItems = 0;
			this.itemsPerPage = 16;
			this.maxVisibleButtons = paginationMaxVisibleButtons;
		},
		applyFilter() {
			this.resetPagination();
			this.fetchProducts();
		},
		uniqueCheck(e) {
			this.filterPrices = [];
			if (e.target.checked) {
				this.filterPrices.push(e.target.value);
			}
			// set filter range price to empty
			this.filterMinimumPrice = '';
			this.filterMaximumPrice = '';

			this.resetPagination();
			this.fetchProducts();
		},
		changeSorting(value) {
			const sortBy = value;
			if (sortBy === 'cheapest') {
				this.sort_by = 'price';
				this.sort = 'asc';
			} else if (sortBy === 'expensive') {
				this.sort_by = 'price';
				this.sort = 'desc';
			} else if (sortBy === 'top-product' && this.user) {
				this.sort_by = 'submission_count';
				this.sort = 'desc';
			} else {
				this.sort_by = 'created_at';
				this.sort = 'desc';
				this.selectedSortBy = this.sort_by;
			}
			this.resetPagination();
			this.fetchProducts();
		},
		onChangeSortBy(event) {
			this.changeSorting(event.target.value);
		},
		fetchProducts() {
			this.fetchProductsPublic();
		},
		onPageChange(page) {
			this.page = page;
			this.fetchProducts();
		},
		checkQuery() {
			this.selectedSortBy = this.getParamsQuery('sort_by') || 'created_at';
			this.changeSorting(this.selectedSortBy);
		},
		removeWishlist(productId) {
			this.products = this.products.filter(product => product._id.$oid !== productId);
			this.totalItems -= 1;
		},
		toggleEditMode(reset = false) {
			this.isEditMode = !this.isEditMode;
			if (reset) {
				this.selectedProductIds = [];
			}
		},
		onAppendProductId(productId) {
			const index = this.selectedProductIds.findIndex(id => id === productId);
			if (index === -1) {
				this.selectedProductIds.push(productId);
			}
		},
		onRemoveProductId(productId) {
			this.selectedProductIds = this.selectedProductIds.filter(id => id !== productId);
		},
		bulkRemoveProducts(selectedProductIds) {
			this.products = this.products.filter(product => !selectedProductIds.includes(product._id.$oid));
		},
		bulkDelete() {
			this.isDeletingWishlist = true;

			const productIds = this.selectedProductIds.toString();

			const params = {
				product_ids: productIds,
			};

			const callback = (response) => {
				this.isDeletingWishlist = false;
				const message = response.message || 'Success';
				this.$notify({
					group: 'app',
					title: 'Wishlist',
					text: message,
					type: 'success',
				});

				this.bulkRemoveProducts(this.selectedProductIds);
				this.bulkRemoveWishlistAdded(this.selectedProductIds);
				this.totalItems -= this.selectedProductIds.length;
				this.toggleEditMode(true);
			};

			const errorCallback = (e) => {
				this.isDeletingWishlist = false;
				const message = getAxiosErrorMessage(e);
				console.log(e);
				this.$notify({
					group: 'app',
					title: 'Wishlist',
					text: message,
					type: 'error',
				});
			};

			wishlistApi.bulkDeleteWishlist(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			searchQuery: 'homepage/searchQuery',
			searchType: 'homepage/searchType',
			user: 'user',
		}),
		isFilterRangeDisabled() {
			return this.filterPrices.length > 0;
		},
		enablePagination() {
			return this.selectedSortBy !== 'top-product';
		},
	},
	created() {
		this.setSearchQuery(this.getParamsQuery('q'));
		this.setSearchType(this.getParamsQuery('st') || 'product');
		this.checkQuery();
		this.fetchCompleteCities();
		if (this.user) {
			this.getDropshipProductAdded();
			this.getProductWishlistAdded();
		}
	},
	watch: {
		'$route.query': {
			handler() {
				this.resetPagination();
				this.checkQuery();
			},
		},
		user() {
			this.getProductWishlistAdded();
		},
	},
};
</script>
<style lang="scss" scoped>
	@import '../assets/scss/modules/_variables.scss';

	.product-search-wrapper {
		margin-top: 40px;
	}

	.card-filter {
		border: none;
		border-radius: 16px;

		.card-filter-title {
			font-style: normal;
			font-weight: 600;
			font-size: 20px;
		}

		.custom-control-label {
			color: #4d4d4d99;
			font-style: normal;
			font-weight: 500;
			font-size: 16px;
		}
	}

	.btn-collapse {
		&.collapsed {
			.bi-chevron-down {
				transform: rotateX(0);
				transition-duration: 0.5s;
			}
		}
	}

	.btn-collapse {
		&:not(.collapsed) {
			.bi-chevron-down {
				transform: rotateX(-180deg);
				transition-duration: 0.5s;
			}
		}
	}

	.custom-checkbox .custom-control-input:checked~.custom-control-label::before{
		background-color: $color__primary;
	}

	.card-product-empty {
		border-radius: 16px;
		padding: 30px;
	}

	.modal {
		.modal-dialog{
			overflow-y: initial !important
		}
		.modal-body{
			height: 290px;
			overflow-y: auto;
		}
		.modal-header{
			background-color: transparent;
		}
		.modal-content{
			border-radius: 16px;
		}
		.modal-footer {
			border-top: none;
			background-color: transparent;
		}
	}

	// Hide arrow input number
	/* Chrome, Safari, Edge, Opera */
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	/* Firefox */
	input[type=number] {
		-moz-appearance: textfield;
	}

	.bulk-delete {
		width: 35%;
	}

	.mobile-button {
		display: none;
	}

	.desktop-button {
		display: block;
	}

	@media only screen and (max-width: 768px) {
		.bulk-delete {
			width: 100%;
		}

		.mobile-button {
			display: block;
		}

		.desktop-button {
			display: none;
		}
	}
</style>
